import React from "react";

const Videos = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.14355 22.274C9.14355 18.3831 9.14355 16.4377 9.89094 14.9515C10.5484 13.6443 11.5974 12.5815 12.8876 11.9154C14.3544 11.1582 16.2746 11.1582 20.115 11.1582H43.8864C47.7268 11.1582 49.647 11.1582 51.1138 11.9154C52.404 12.5815 53.453 13.6443 54.1105 14.9515C54.8578 16.4377 54.8578 18.3831 54.8578 22.274V41.7266C54.8578 45.6175 54.8578 47.563 54.1105 49.0491C53.453 50.3563 52.404 51.4191 51.1138 52.0852C49.647 52.8424 47.7268 52.8424 43.8864 52.8424H20.115C16.2746 52.8424 14.3544 52.8424 12.8876 52.0852C11.5974 51.4191 10.5484 50.3563 9.89094 49.0491C9.14355 47.563 9.14355 45.6175 9.14355 41.7266V22.274Z"
        fill="url(#paint0_linear_3991_2928)"
      />
      <path
        d="M25.1436 11.1582L22.8578 22.7372M41.1436 11.1582L38.8578 22.7372M54.8578 22.7372H9.14355M20.115 52.8424H43.8864C47.7268 52.8424 49.647 52.8424 51.1138 52.0852C52.404 51.4191 53.453 50.3563 54.1105 49.0491C54.8578 47.563 54.8578 45.6175 54.8578 41.7266V22.274C54.8578 18.3831 54.8578 16.4377 54.1105 14.9515C53.453 13.6443 52.404 12.5815 51.1138 11.9154C49.647 11.1582 47.7268 11.1582 43.8864 11.1582H20.115C16.2746 11.1582 14.3544 11.1582 12.8876 11.9154C11.5974 12.5815 10.5484 13.6443 9.89094 14.9515C9.14355 16.4377 9.14355 18.3831 9.14355 22.274V41.7266C9.14355 45.6175 9.14355 47.563 9.89094 49.0491C10.5484 50.3563 11.5974 51.4191 12.8876 52.0852C14.3544 52.8424 16.2746 52.8424 20.115 52.8424Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4287 42.7992V32.7791C27.4287 31.9089 28.3626 31.3579 29.1244 31.7789L38.1901 36.7889C38.9769 37.2237 38.9769 38.3547 38.1901 38.7894L29.1244 43.7995C28.3626 44.2204 27.4287 43.6695 27.4287 42.7992Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3991_2928"
          x1="55.8374"
          y1="52.8424"
          x2="4.99493"
          y2="46.9491"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E30BF" />
          <stop offset="1" stopColor="#AF30BF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Videos;
